import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParamDefaults, ConfigSystemParams, modalFormValues, msSize, TypeDevice } from 'src/app/core/consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { CommunicationTemplate } from 'src/app/core/models/system/communication/communication-template';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeviceActivationType, DeviceOSType, DeliveryType, MessageType } from 'src/app/core/enums';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimProvisioningDTO } from 'src/app/core/models/system/provisioning/esim-provisoning.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrderMiniDTO } from 'src/app/core/models/system/order/order-mini.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-redeploy-modal-form',
  templateUrl: './redeploy-modal-form.component.html',
  styleUrls: ['./redeploy-modal-form.component.scss']
})

export class RedeployModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;

  @Output() redeployOrderUpdated : EventEmitter<{orderId:number,eid: string}>=new EventEmitter<{orderId:number,eid: string}>();
  @Output() redeployCancelled    : EventEmitter<void>=new EventEmitter<void>();
  @Output() redeploySuccessful   : EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('completedModalForm',        { static: false }) completedModalForm!       : CompletedModalFormComponent;
  @ViewChild('eidfield',                  { static: false }) eidInput!                 : ElementRef<HTMLInputElement>;
  @ViewChild('redployModalFormContent',   { static: false }) redployModalFormContent!  : TemplateRef<void>;
  @ViewChild('warningModalForm',          { static: false }) warningModalForm!         : WarningModalFormComponent;

  get canEditCustomiseMessage      () { return this.authenticationService.canEditSystemOwned(this.customiseMessageTemplate?.systemOwned ?? false);         }
  get customiseMessageCharacters   () { return this.customiseMessageText().length;                                                                         }
  get customiseMessageDefaultText  () { return this.deliveryMethod == 'sms'    ? this.defaultProvisionViaSMSText    :
                                               this.deliveryMethod == 'manual' ? this.defaultProvisionViaManualText : this.defaultProvisionViaEmailText;   }
  get customiseMessageReplacements () { return this.deliveryMethod == 'sms'    ? this.templateSMSReplacements       :
                                               this.deliveryMethod == 'manual' ? this.templateManualReplacements    : this.templateEmailReplacements;      }
  get customiseMessageTemplate     () { return this.deliveryMethod == 'sms'    ? this.smsTemplate                   :
                                               this.deliveryMethod == 'manual' ? this.manualTemplate                : this.emailTemplate;                  }
  get customiseMessageTitle        () { return this.deliveryMethod == 'sms'    ? "Customise SMS message" : "Customise email message";                      }
  get defaultProvisionViaEmailText () { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaEmailText,  "");     }
  get defaultProvisionViaManualText() { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaManualText, "");     }
  get defaultProvisionViaSMSText   () { return this.configSystemService.getValue(ConfigSystemParams.CommunicationTemplatesProvisionViaSMSText,    "");     }
  get modalBackGround              () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                                        return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true :          false); }
            
  get mustHaveLicence              () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPlatformMustHaveForProvision, false); }
  get ShowPushViaSMSEmail          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowPushViaSMSEmail,                  false); }

  get showManualProvisioningButton () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ProvisioningShowManualButton, true         ) &&
                                               this.componentAccessUserService.hasAccessGuid(AccessGuids.FormProvisionManualProvisionButton             ) &&
                                               !this.deviceActivated                                                                                      ; }

  private completedOrderStatus          : string="Redeployed";
  private customiseMessageOriginalText  : string="";
  private initialStatus                 : string="Please complete the following details";
  private initialOrderStatus            : string="Pending";
  private redeployModalFormRef!         : NgbModalRef;
  private selectedInviewCompany?        : IdAndDescriptionDTO;
  private sureSimOrder                  : OrderDTO | undefined;
  private sureSimOrderUpdated           : boolean=false;

  public redeployForm!                  : UntypedFormGroup;
  public alertColourOrderStatus         : string=AlertClassColour.Grey;
  public alertColourProgress            : string=AlertClassColour.Grey;
  public availableOnly                  : boolean=false;
  public breadCrumbItems!               : Array<{}>;
  public currUser                       : SystemUserDTO;
  public customiseMessageBody           : string="";
  public customiseMessageExpanded       : boolean=false;
  public customiseMessageForm!          : UntypedFormGroup;
  public deliveryMethod                 : string = '';
  public deviceActivated                : boolean=false;
  public DeviceActivationTypePushViaSMSEmail: number=DeviceActivationType.SendViaSMSEmail;
  public deviceType                     : string = '';
  public eid                            : string="";
  public eidRadioSelection              : string="";
  public emailTemplate                  : CommunicationTemplateDTO | undefined;
  public existingEid                    : string="";
  public formSubmitted                  : boolean=false;
  public manualActivationCode           : string | undefined;
  public manualActivationDetailsVisible : boolean=false;
  public manualActivationServer         : string | undefined;
  public manualTemplate                 : CommunicationTemplateDTO | undefined;
  public formTitleDefault               : string="Redeploy";
  public formTitle                      : string=this.formTitleDefault;
  public orderStatusInformation         : string=this.initialOrderStatus;
  public preventAutofill                : boolean=true;
  public redeployInProgress             : boolean=false;
  public progressInformation            : string=this.initialStatus;
  public searchForInviewUser            : boolean=false;
  // public selectedActivationTypeId       : number=0;
  // public selectedDeviceOSTypeId         : number=0;
  public selectedDeviceTypeId           : number=0;
  public selectedInviewCompanyId        : number | undefined;
  public selectedInviewUserId           : number | undefined;
  public showSMSEmail                   : boolean=false;
  public smsTemplate                    : CommunicationTemplateDTO | undefined;
  public templateEmailReplacements      : CommunicationTemplateReplacements[] = [];
  public templateManualReplacements     : CommunicationTemplateReplacements[] = [];
  public templateSMSReplacements        : CommunicationTemplateReplacements[] = [];
  public sureSimOrderDetails            : OrderMiniDTO | undefined;
  public sureSimUser                    : UserDTO | undefined;
  public warningMessageMain             : string | undefined;
  public warningMessageSub              : string | undefined;

  public deliveryMethods = [
    { id: 'eid',    label: 'EID',    icon: '📱', desc: 'Direct eSIM push via device EID'       },
    { id: 'sms',    label: 'SMS',    icon: '💬', desc: 'Send activation link via text message' },
    { id: 'email',  label: 'Email',  icon: '✉️', desc: 'Send activation link via email'        },
    { id: 'manual', label: 'Manual', icon: '📄', desc: 'Display activation details on screen'  }
  ];

  public deviceTypes = [
    { id: 'ios',     label: 'iOS',     icon: '🍏', desc: 'iPhone / iPad' },
    { id: 'android', label: 'Android', icon: '🤖', desc: 'Samsung, Pixel, etc.' },
    { id: 'windows', label: 'Windows', icon: '💻', desc: 'Windows 11 eSIM devices' }
  ];

  get filteredDeliveryMethods() {
    return this.deliveryMethods.filter(d => {
      if (d.id === 'manual') return this.showManualProvisioningButton;
      if (d.id === 'eid')    return true;
      return this.showSMSEmail;
    });
  }

  get filteredDeviceTypes() {
    if (this.deliveryMethod==="sms") {
      return this.deviceTypes.filter(d => d.id === 'ios' || d.id === 'android')
    } else {
      return this.deviceTypes;
    }
  }

  constructor(
    private authenticationService          : AuthenticationService,
    private commConfigsService             : CommConfigService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private exceptionsService              : ExceptionsService,
    private devicesService                 : DevicesService,
    private formBuilder                    : UntypedFormBuilder,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private ordersService                  : OrdersService,
    private usersService                   : UsersService,
    private validatorService               : ValidatorService
  ) {
    this.currUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.orderStatusInformation=this.initialOrderStatus;

      if (this.embeddedFormMode) {
        this.startProcess(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      this.redeployCancelled.emit();

      if (this.redeployModalFormRef != undefined) {
        this.redeployModalFormRef.close();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimOrder() {
    try {
      this.ordersService.getById(<number>this.sureSimOrderDetails?.orderID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder=data;
          if (this.showSMSEmail || this.showManualProvisioningButton) {
            if (this.showSMSEmail) {
              this.getTemplateData(MessageType.ProvisioningViaEmail, DeliveryType.Email);
              this.getTemplateData(MessageType.ProvisioningViaSMS,   DeliveryType.SMS);
            }
            if (this.showManualProvisioningButton) {
              this.getTemplateData(MessageType.ProvisioningViaManual, DeliveryType.Email);
            }
            this.getTemplateReplacements();
          }
          this.getUser(this.sureSimOrder?.userID ?? -1);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getUser(suresimUserId:number) {
    this.usersService.getById(suresimUserId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
  }

  public isRedeployButtonEnabled() {
    var result = false;
    result = (((this.deliveryMethod === 'eid'    && this.eidRadioSelection != "" && this.redeployForm.controls["eid"].value != "") ||
               (this.deliveryMethod === 'email'  && this.deviceType != '') ||
               (this.deliveryMethod === 'sms'    && this.deviceType != '') ||
               (this.deliveryMethod === 'manual')) && this.redeployForm.valid && this.customiseMessageIsValid());
    return result;
  }

  public getRedeployButtonText() {
    var buttonText = "Redeploy";

    if (this.deliveryMethod === 'email' ) {
       buttonText = "Redeploy Via Email";
    } else if (this.deliveryMethod === 'sms')  {
       buttonText = "Redeploy Via SMS";
    } else if (this.deliveryMethod === 'eid' && this.eidRadioSelection != "") {
       buttonText = this.eidRadioSelection == "replacement" ? "Deploy" : "Redeploy";
    }

    return buttonText;
  }
 
  public resetMainVariables(IsFormOpening : boolean): void {
    try {
      this.alertColourProgress      = AlertClassColour.Grey;
      this.customiseMessageExpanded = false;
      this.deliveryMethod           = "";
      this.deviceType               = "";
      this.eidRadioSelection        = "";
      this.formSubmitted            = false;
      this.formTitle                = this.formTitleDefault + ' - ' + (this.sureSimOrderDetails?.iccid ?? "");
      this.progressInformation      = this.initialStatus;
      this.selectedInviewCompanyId  = undefined;
      this.selectedInviewUserId     = undefined;
      this.redeployInProgress       = false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(sureSimOrderDetails: OrderMiniDTO, deviceTypeId: number, eid: string, activated: boolean): void {
    try {
      this.eid                  = eid;
      this.existingEid          = eid,
      this.sureSimOrderDetails  = sureSimOrderDetails;
      this.selectedDeviceTypeId = deviceTypeId
      this.availableOnly        = true;
      this.deviceActivated      = activated;
      this.showSMSEmail         = (sureSimOrderDetails.status == "Sent - SMS/email"    ||
                                   sureSimOrderDetails.status == "Awaiting Download"   ||
                                   sureSimOrderDetails.status == "Awaiting Deployment"
                                  ) && this.ShowPushViaSMSEmail && !activated;

      this.getSureSimOrder();
      this.startProcess(true);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.redeployModalFormRef = this.modalService.open(this.redployModalFormContent, { backdrop: this.modalBackGround,
                                                                                         centered: true,
                                                                                         keyboard: false,
                                                                                         size    : this.filteredDeliveryMethods.length >= 4 ? msSize.Large : msSize.Medium });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startProcess(IsFormOpening : boolean): void {
    try {
      this.resetMainVariables(IsFormOpening);
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region redeployForm

  get formData() {
    return this.redeployForm.controls;
  }

  private setUpForm() {
    try {
      //this.getOrder();
      this.buildForm();
      this.enableDisableControls(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.redeployForm=this.formBuilder.group({ });

      this.addFormFields(this.redeployForm);

      this.buildCustomiseMessageForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public exisingEidRequiredValidator(existingEid:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const radioControl = parent.get("eidRadio");
        var result = radioControl && radioControl.value == "existing" && (value != null && value != existingEid) ? { existingEidRequired: true } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  public newEidRequiredValidator(existingEid:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const radioControl = parent.get("eidRadio");
        var result = radioControl && radioControl.value == "replacement" && (value != null && value == existingEid) ? { newEidRequired: true } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.redeployForm) {
        // this.addFormControl(formGroup, "activationTypeId", "", [Validators.required]);
        // this.addFormControl(formGroup, "deviceOSTypeId",   "", [Validators.required]);
        this.addFormControl(formGroup, "eidRadio",         "", [Validators.required]);
        this.addFormControl(formGroup, "eid",        this.eid, [Validators.required, Validators.minLength(32), Validators.maxLength(32), Validators.pattern('^[0-9]{32,32}$'), this.exisingEidRequiredValidator(this.existingEid), this.newEidRequiredValidator(this.existingEid)]);

        // if (this.showSMSEmail) {
        //   this.redeployForm.controls["activationTypeId"].enable();
        // } else {
        //   this.redeployForm.controls["activationTypeId"].disable();
        // }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
 
  // private removeFormFields(form: UntypedFormGroup) {
  //   try {
  //     if (form != undefined) {
  //       for (let control in form.controls) {
  //         form.removeControl(control);
  //       }
  //     }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  public saveFormData() {
    try {
      if (!this.redeployInProgress)
      {
        this.formSubmitted=true;
   
        if (this.redeployForm.valid)
        {
          let esimProvisioningDTO: EsimProvisioningDTO={
            activationTypeId: this.deliveryMethod == 'eid'    ? DeviceActivationType.PushViaEID    :
                              this.deliveryMethod == 'manual' ? DeviceActivationType.SendViaManual :
                                                                DeviceActivationType.SendViaSMSEmail,
            eid             : this.redeployForm.controls["eid"].value,
            enteredBy       : this.currUser.userId,
            deviceId        : this.sureSimOrder!.deviceID,
            deviceOSTypeId  : this.deliveryMethod == "email" ? DeviceOSType.Windows : this.deviceType == "android" ? DeviceOSType.Android : DeviceOSType.AppleIOS,
            deviceTypeId    : this.selectedDeviceTypeId,
            iccid           : this.sureSimOrderDetails!.iccid,
            inviewCompanyId : this.sureSimUser!.inviewCompanyID ?? -1,
            inviewUserId    : this.sureSimUser?.inviewUserID ?? -1,
            orderGuid       : "",
            orderNumber     : this.sureSimOrder!.orderNo,
            productId       : this.sureSimOrder!.productID,
            provisionTypeId : 2,
            reserved        : false
          }
  
          this.saveCustomiseMessage(() => {
            if (this.redeployForm.controls["eid"].value != this.existingEid)
            {
              this.saveOrder(esimProvisioningDTO);
            } else {
              this.doRedeploy(esimProvisioningDTO);
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public saveOrder(esimProvisioningDTO : EsimProvisioningDTO) {
    try {
      this.sureSimOrder!.eid            = this.redeployForm.controls["eid"].value;
      this.sureSimOrder!.updatedByUserId= this.currUser.userId;

      this.ordersService.save(<OrderDTO>this.sureSimOrder)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder = data;
          this.sureSimOrderDetails!.orderID = <number>this.sureSimOrder?.id;
          this.sureSimOrderUpdated = true;
          this.doRedeploy(esimProvisioningDTO);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectMethod(id: string) {
    this.customiseMessageExpanded       = false;
    this.deliveryMethod = id;
    this.deviceType = '';
    this.manualActivationDetailsVisible = false;
    this.manualActivationCode           = undefined;
    this.manualActivationServer         = undefined;

    this.populateCustomiseMessage();

    this.setOrClearValidators();
  }

  public copyToClipboard(value: string | undefined): void {
    try {
      if (value != undefined && value != '') {
        navigator.clipboard.writeText(value);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setDeviceType(type: string) {
    this.deviceType = type;
  }

  public setOrClearValidators() {
    this.validatorService.setOrClearValidators(this.redeployForm,
                                               "eid",
                                               !(this.deliveryMethod == 'sms' || this.deliveryMethod == 'email' || this.deliveryMethod == 'manual'),
                                               [Validators.required, Validators.minLength(32), Validators.maxLength(32), Validators.pattern('^[0-9]{32,32}$'), this.exisingEidRequiredValidator(this.existingEid), this.newEidRequiredValidator(this.existingEid)]);
    this.validatorService.setOrClearValidators(this.redeployForm,
                                               "eidRadio",
                                               !(this.deliveryMethod == 'sms' || this.deliveryMethod == 'email' || this.deliveryMethod == 'manual'),
                                               [Validators.required]);
    // this.validatorService.setOrClearValidators(this.redeployForm,
    //                                            "deviceOSTypeId",
    //                                            (this.selectedActivationTypeId == DeviceActivationType.SendViaSMSEmail),
    //                                            [Validators.required]);
  }

  private enableDisableControls(enabled: boolean) {
    try {
      if (enabled) {
        this.redeployForm.controls["eid"].enable();
      } else {
        this.redeployForm.controls["eid"].disable();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disableAllControls() {
    try {
      this.redeployForm.controls["eid"].disable();     
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#endregion

  //#region Provisioning

  // public activationTypeSelectDropDownChange(event: Event | undefined) {
  //   try {
  //     this.selectedActivationTypeId=this.redeployForm.controls["activationTypeId"].value;
  //     this.setOrClearValidators();
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  private addCustomError(controlName: string, errorKey: string, errorValue: any) {
    const control = this.redeployForm.get(controlName);
    if (control) {
      control.setErrors({ ...control.errors, [errorKey]: errorValue });
    }
  }

  // public deviceOSTypeSelectDropDownChange(event: Event | undefined) {
  //   try {
  //     this.selectedDeviceOSTypeId = this.redeployForm.controls["deviceOSTypeId"].value;
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  private showMessageWarning(messageError: string | undefined): void {
    try {
      if (messageError == undefined || messageError == '') {
        return;
      }

      this.warningMessageMain=(this.deliveryMethod === 'sms' ? "The SIM was redeployed but the SMS could not be sent"
                                                            : "The SIM was redeployed but the email could not be sent");
      this.warningMessageSub =messageError;

      this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private doRedeploy(esimProvisioningDTO : EsimProvisioningDTO): void {
    try {
      this.redeployInProgress = true;

      this.devicesService.provisionNextAvailableDevice(esimProvisioningDTO)
      .pipe(
        catchError((error) => {
          this.redeployInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.orderStatusInformation = this.completedOrderStatus;
          this.redeployInProgress = false;

          if (this.sureSimOrderUpdated) {
            this.redeployOrderUpdated.emit({orderId:this.sureSimOrderDetails?.orderID ?? -1,eid:this.sureSimOrder?.eid ?? ""});
          }

          if (this.deliveryMethod === 'manual') {
            this.manualActivationServer         = data.activationServer;
            this.manualActivationCode           = data.activationCode;
            this.manualActivationDetailsVisible = true;
            this.redeploySuccessful.emit();

            this.showMessageWarning(data.messageError);

          } else if (data.messageError != undefined && data.messageError != '') { //RBW_20260827 - The SIM is provisioned, only the message failed
            this.redeploySuccessful.emit();
            this.showMessageWarning(data.messageError);

          } else {
            this.processComplete();
          }
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.redeployInProgress = false;
            this.enableDisableControls(false);

            this.warningMessageMain="There are no eSIMs available";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else if (error.message && error.message.includes("Failed searching for next available sim")) {
            this.redeployInProgress  = false;
            this.enableDisableControls(true);
            this.addCustomError('deviceId', 'alreadyProvisioned', 'Please select different ICCID, this one is no longer available');

          } else {
            this.redeployInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.redeployInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

public onRadioChange(radioClicked: string) : void
{
  try {
    this.eidRadioSelection  = radioClicked;
    if (radioClicked == "existing")
    {
      this.redeployForm.controls["eid"].setValue(this.existingEid);
    }
    this.enableDisableControls(radioClicked == "replacement");
  }
  catch(e) {
    this.exceptionsService.handleException(<Error>e);
  }
}

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      this.redeploySuccessful.emit();
      this.completedModalForm.openForm("Congratulations", "This sim has been redeployed");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Templates

  private getTemplateData(messageType : number, deliveryType : number) {
    try {
      if (this.sureSimOrder?.companyID != undefined && this.sureSimOrder?.companyID>0) { 
        this.commConfigsService.getCommunicationTemplate(this.sureSimOrder?.companyID as number, messageType, deliveryType)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
        .subscribe({
          next: data => {
              if (data.messageTypeId == MessageType.ProvisioningViaEmail)
                this.emailTemplate=data;
              if (data.messageTypeId == MessageType.ProvisioningViaSMS)
                this.smsTemplate=data;
              if (data.messageTypeId == MessageType.ProvisioningViaManual)
                this.manualTemplate=data;

              this.refreshCustomiseMessage();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
          })
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
         return (undefined);
      }
    }

  private getTemplateReplacements() {
    try {
      this.commConfigsService.getCommunicationTemplateReplacements(this.currUser.userId, MessageType.ProvisioningViaEmail).subscribe(x => this.templateEmailReplacements = x);
      this.commConfigsService.getCommunicationTemplateReplacements(this.currUser.userId, MessageType.ProvisioningViaSMS).subscribe(x => this.templateSMSReplacements = x);
      this.commConfigsService.getCommunicationTemplateReplacements(this.currUser.userId, MessageType.ProvisioningViaManual).subscribe(x => this.templateManualReplacements = x);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Customise Message

  private buildCustomiseMessageForm(): void {
    try {
      this.customiseMessageForm=this.formBuilder.group({ });

      this.addFormControl(this.customiseMessageForm, "messageBody", "", []);

      this.populateCustomiseMessage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260827 - Mirrors the backend that appends these at send time
  private insertMandatorySystemValues(body: string): string {
    try {
      let updatedBody=(body ?? "").replace(/\r\n/g, "\n");

      if (this.deliveryMethod=='sms' || this.deliveryMethod=='email') {
        if (!updatedBody.includes("@@ActivationLink")) {
          updatedBody+="\n\n@@ActivationLink";
        }
      }

      if (this.deliveryMethod=='manual') {
        if (!updatedBody.includes("@@ActivationServer")) {
          updatedBody+="\n\nActivation Server: @@ActivationServer";
        }

        if (!updatedBody.includes("@@ActivationCode")) {
          updatedBody+="\nActivation Code: @@ActivationCode";
        }
      }

      return updatedBody;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return body;
    }
  }

  private populateCustomiseMessage(): void {
    try {
      const template=this.customiseMessageTemplate;

      this.customiseMessageOriginalText=template==undefined ? "" : this.insertMandatorySystemValues(template.body ?? "");

      this.customiseMessageBody=this.customiseMessageOriginalText;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshCustomiseMessage(): void {
    try {
      if (this.customiseMessageText()==this.customiseMessageOriginalText) {
        this.populateCustomiseMessage();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveCustomiseMessage(onSaved: () => void): void {
    try {
      const template=this.customiseMessageTemplate;
      const body    =this.customiseMessageText();

      if (!this.customiseMessageVisible() || !this.canEditCustomiseMessage || template==undefined ||
          body.trim()=="" || body==this.customiseMessageOriginalText) {
        onSaved();
        return;
      }

      this.redeployInProgress=true;

      const saveBody: CommunicationTemplate={
        AlertTypeId         : template.alertTypeId,
        ID                  : template.id,
        CommunicationTypeId : template.communicationTypeId,
        CompanyId           : this.sureSimOrder?.companyID,
        DeliveryTypeId      : this.deliveryMethod=='sms' ? DeliveryType.SMS : DeliveryType.Email,
        MessageTypeId       : template.messageTypeId,
        Name                : template.name,
        Subject             : template.subject,
        Body                : body,
        CC                  : template.cc,
        BCC                 : template.bcc,
        FromEmail           : template.fromEmail,
        FromNumber          : template.fromNumber,
        SendToUser          : template.sendToUser,
        SendElsewhere       : template.sendElsewhere,
        ToEmail             : template.toEmail,
        ToNumber            : template.toNumber,
        UseDefaultCC        : template.useDefaultCC,
        UseDefaultBCC       : template.useDefaultBCC,
        UseDefaultFromEmail : template.useDefaultFromEmail,
        UseDefaultFromNumber: template.useDefaultFromNumber,
        UseDefaultToEmail   : template.useDefaultToEmail,
        UseDefaultToNumber  : template.useDefaultToNumber,
        EnteredBy           : this.currUser.userId,
        Active              : true,
        Deleted             : false,
        SystemOwned         : false
      };

      (template.id>0 ? this.commConfigsService.editCommunicationTemplate(saveBody)
                     : this.commConfigsService.createCommunicationTemplate(saveBody))
      .pipe(
        catchError((error) => {
          this.redeployInProgress=false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: id => {
          if (template.id<=0) {
            template.id=id;
          }

          template.body                    =body;
          this.customiseMessageOriginalText=body;
          this.redeployInProgress          =false;

          onSaved();
        },
        error: error => {
          this.redeployInProgress=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.redeployInProgress=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public customiseMessageInvalidPlaceHolders(): string {
    try {
      const replacements       =this.customiseMessageReplacements ?? [];
      let   invalidPlaceHolders="";

      this.customiseMessageText()
          .trim()
          .replace(/\,/," ")
          .replace(/@@/g," @@")
          .split(/\s+/)
          .forEach(word => {
            if (word.startsWith('@@') && !replacements.some(x => word.startsWith(x.placeHolder ?? ""))) {
              invalidPlaceHolders+=',' + word;
            }
          });

      return invalidPlaceHolders=="" ? "" : invalidPlaceHolders.substring(1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageWarning(): string {
    try {
      if (this.customiseMessageIsValid()) {
        return "";
      }

      return this.customiseMessageInvalidPlaceHolders()=="" ? "A message is required" : "Unknown system value(s) found";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageIsValid(): boolean {
    try {
      if (!this.customiseMessageVisible()) {
        return true;
      }

      return this.customiseMessageText().trim()!="" && this.customiseMessageInvalidPlaceHolders()=="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  public customiseMessageText(): string {
    try {
      return this.customiseMessageBody ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public customiseMessageVisible(): boolean {
    try {
      return this.sendingToVisible() && this.customiseMessageTemplate != undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //RBW_20261020 - The panel resets to whatever this returns, so the mandatory values are folded in here rather
  //               than the panel having to know about them.
  public customiseMessageResetText(): string {
    try {
      return this.insertMandatorySystemValues(this.customiseMessageDefaultText);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public onCustomiseMessageExpandedChange(expanded: boolean): void {
    try {
      if (expanded) {
        this.refreshCustomiseMessage();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Sending To

  public sendingToDescription(): string {
    try {
      if (this.deliveryMethod=='manual') {
        return "A copy of the activation details will be sent to this address.";
      }

      if (this.sendingToMissing()) {
        return this.deliveryMethod=='sms' ? "This user has no mobile number on their user profile, so the SMS cannot be sent."
                                          : "This user has no email address on their user profile, so the email cannot be sent.";
      }

      return this.deliveryMethod=='sms' ? "An SMS will be sent to the mobile number on the user's profile."
                                        : "An email will be sent to the email address on the user's profile.";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public sendingToMissing(): boolean {
    try {
      return this.sendingToVisible() && this.deliveryMethod != 'manual' && this.sureSimUser != undefined && this.sendingToValue()=="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public sendingToValue(): string {
    try {
      if (this.deliveryMethod=='manual') {
        return this.currUser.username;
      }

      if (this.deliveryMethod=='email') {
        return this.sureSimUser?.email ?? "";
      }

      const mobile=this.sureSimUser?.mobile ?? "";

      return mobile.trim() != "" ? mobile : this.sureSimUser?.mobileE164 ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public sendingToVisible(): boolean {
    try {
      if (this.deliveryMethod=='manual') {
        return true;
      }

      return (this.deliveryMethod=='sms' || this.deliveryMethod=='email') && this.sureSimUser != undefined && this.deviceType != '';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion
 
  //#region System Licence Check & Possible Lockdown

  public userCanProvision(companyId: number | undefined) {
    try {
      if (this.mustHaveLicence) {
        //this.warningModalForm.closeForm();

        if (companyId && Number(companyId)>0) {
          this.devicesService.totalLiveDevicesForCompany(companyId)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              const totalLiveDevices: number=data.result;
              
              this.licencesCompanyAllocatedService.totalLivePlatformLicencesForCompany(companyId)
              .pipe(
                catchError((error) => {
                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                })
              )
              .subscribe({
                next: data => {
                  const totalPlatformLicences=data.result;

                  if (totalLiveDevices>=totalPlatformLicences) {
                    //this.warningModalForm.openForm("Cannot proceed", Company has a total of ${totalPlatformLicences} licences and ${totalLiveDevices} have been used`);
                    this.progressInformation=`Cannot Proceed - ${this.selectedInviewCompany?.description} has a total of ${totalPlatformLicences} licences and ${totalLiveDevices} ${totalLiveDevices==1 ? "has" : "have"} been used`;
                    this.alertColourProgress=AlertClassColour.Red;
                    this.disableAllControls();

                  } else {
                    this.progressInformation=`Can Proceed - ${this.selectedInviewCompany?.description} has a total of ${totalPlatformLicences} licences and ${totalLiveDevices} ${totalLiveDevices==1 ? "has" : "have"} been used`;
                    this.alertColourProgress=AlertClassColour.Green;
                  }
                },
                error: error => {
                  this.exceptionsService.handleException(new Error(error));
                }
              });
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });

        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
